<template>
    <div class="system">
        <img src="../assets/system.png"/>
        <p>系统维护中</p>
        <p style="font-size: 1rem">{{ message }}</p>
    </div>
</template>

<script>
    export default {
        name: "System",
        data() {
            return {
                message: '',
            }
        },

        mounted() {
            this.message = localStorage.getItem('maintenance');
        }
    }
</script>

<style lang="scss" scoped>

    .system {
        width: 100%;
        height: 100%;
        background: #ed3f14;
        position: fixed;
        img {
            width: 142px;
            margin-top: 40px;
        }

        p {
            font-size: 2rem;
            margin: 40px;
            color: #FFFFFF;
        }

    }
</style>